var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanSummaryBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1005,
    height: 340,
    viewBox: "0 0 1005 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1005 0H502.5H251.25H125.625H62.8125H0V42.5V85V170V340H949.475H1005L1005 297.5V255V170V0Z",
    fill: "url(#paint0_linear_98_70)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_98_70_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.180755 -0.0448259 0.0262366 -0.00579074 -46.9964 170)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -35140.8,
    y: -35140.8,
    width: 70281.7,
    height: 70281.7
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(45, 19, 73, 1) 0deg,rgba(35, 26, 61, 1) 102.151deg,rgba(55, 13, 85, 1) 265.11deg,rgba(45, 19, 73, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1005 0H502.5H251.25H125.625H62.8125H0V42.5V85V170V340H949.475H1005L1005 297.5V255V170V0Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.13725490868091583,\"g\":0.10196078568696976,\"b\":0.23921568691730499,\"a\":1.0},\"position\":0.28375384211540222},{\"color\":{\"r\":0.21568629145622253,\"g\":0.052941177040338516,\"b\":0.33333334326744080,\"a\":1.0},\"position\":0.73641765117645264}],\"stopsVar\":[{\"color\":{\"r\":0.13725490868091583,\"g\":0.10196078568696976,\"b\":0.23921568691730499,\"a\":1.0},\"position\":0.28375384211540222},{\"color\":{\"r\":0.21568629145622253,\"g\":0.052941177040338516,\"b\":0.33333334326744080,\"a\":1.0},\"position\":0.73641765117645264}],\"transform\":{\"m00\":-361.51083374023438,\"m01\":52.473297119140625,\"m02\":107.52239990234375,\"m10\":-89.651748657226562,\"m11\":-11.581479072570801,\"m12\":220.61662292480469},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1005 0H502.5H251.25H125.625H62.8125H0V42.5V85V170V340H949.475H1005L1005 297.5V255V170V0Z",
    fill: "url(#paint2_linear_98_70)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_98_70_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1005 0H502.5H251.25H125.625H62.8125H0V42.5V85V170V340H949.475H1005L1005 297.5V255V170V0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_70",
    x1: 502.5,
    y1: 0,
    x2: 502.5,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B016D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_70",
    x1: 542.266,
    y1: 260.498,
    x2: 564.861,
    y2: 347.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanSummaryBg);
export default __webpack_public_path__ + "static/media/planSummaryBg.fa2d56c2051fcdd9bd348cd9dc3333b4.svg";
export { ForwardRef as ReactComponent };